import styled, { keyframes } from 'styled-components';
import 'antd/dist/antd.css';

export const Container = styled.div`
  height:100vh;
  width:100%;
  overflow:hidden;
  background:#fff;
  display:flex;
  align-items:center;
  justify-content:center;
  img{
      width:500px;
  }
`;
export const ProfileSection = styled.div`
    height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;
export const Profile = styled.div`
    height: 70%;
    width: 60%;
    border-radius:20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    .info{
        display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    }
    &.createRoom{
        height: 85% !important;
    }
    button {
        border: 2px solid;
        border-radius: 23px;
        width: 170px;
        background: #000;
        padding: 10px;
        color: #fff;
        text-transform: uppercase;
        font-size: 14px;
    }
`;
export const SignInUp = styled.div`
width:500px;
.nav-tabs {
    border: 1px solid transparent;
    align-items: center;
    justify-content: center;
    margin:30px;
    margin-top:0 !important;
}
.nav-tabs .nav-link {
    text-transform: uppercase;
    color: #000;
}
.nav-tabs .nav-link:focus, .nav-tabs .nav-link:hover {
    border-color: transparent;
}
.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
    color: #000;
    font-weight: 500;
    text-transform: uppercase;
    background-color: #fff;
    border-color: transparent;
    border-bottom: 2px solid #000 !important;
}
p{
    margin:10px;
}
.btn-primary,button{
    background:#000;
    color:#fff;
    border:2px solid #000;
    min-width: 150px;
    font-size:13px;
    border-radius: 20px;    
    padding: 5px !important;
    padding-left: 10px !important;
    padding-right:10px !important;
    text-transform: uppercase;
    margin-top:20px!important;
}
button{
    margin-top:0px !important;
}
.auth-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height:300px;
}
.form-group {
    margin-bottom: 1rem;
    width:70%;
}
.form-control {
    border:none !important;
    border-radius: 0 !important;
    border-bottom: 2px solid #e4f5ff !important;
}
.form-control:focus,.form-control:hover {
    color: #495057;
    background-color: #fff;
    border-color: #fff;
    outline: 0;
    box-shadow:none !important;
}
label {
    font-size: 14px;
    font-weight: 500;
}
`;
export const UserInfo = styled.div`
    display: flex;
    flex-direction: row;    
    margin: 50px;
    align-items: center;
    justify-content: center;
    .anticon svg {
        display: inline-block;
        margin-right: 5px;
        margin-bottom: 10px;
    }
    p{
        margin: 10px !important;
        height: 30px;
        text-transform: uppercase;
        font-size: 15px;
        font-weight: 600;
    }
`;
export const CreateRoomTab = styled.div`
width:100%;
.nav-tabs {
    border: 1px solid transparent;
    align-items: center;
    justify-content: center;
    margin:30px;
    margin-top:0 !important;
}
.nav-tabs .nav-link {
    text-transform: uppercase;
    color: #000;
}
.nav-tabs .nav-link:focus, .nav-tabs .nav-link:hover {
    border-color: transparent;
}
.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
    color: #000;
    font-weight: 500;
    text-transform: uppercase;
    background-color: #fff;
    border-color: transparent;
    border-bottom: 2px solid #000 !important;
}
p{
    margin:10px;
}
form{
        width: 600px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
}
// .auth-form {
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     justify-content: center;
//     height:300px;
// }
.scroll-section{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-height: 350px;
    overflow-y: auto;
    padding: 1rem 0;
}
.form-group {
    margin-bottom: 1rem;
    width:70%;
}
.form-control {
    border:none !important;
    border-radius: 0 !important;
    border-bottom: 2px solid #e4f5ff !important;
}
.form-control:focus,.form-control:hover {
    color: #495057;
    background-color: #fff !important;
    border-color: #fff;
    outline: 0;
    box-shadow:none !important;
}
.form-control:disabled, .form-control[readonly] {
    background-color: #e1f4ff8c !important;
}
label {
    font-size: 14px;
    font-weight: 500;
}
.tab-content>.active {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Roboto', sans-serif;
}
input{
    font-size:14px !important;
    font-family: 'Roboto',sans-serif;
}
`
export const Boards = styled.div`
    display: flex;
    height: 100%;
    width:80%;
    overflow:hidden;
    overflow-y:auto;
    flex-direction:column;
    align-items: center;
    padding:20px;
 .anticon svg {
        display: inline-block;
        width: 30px;
        height: 30px;
    }
    img {
        height: 35px;
        width: 35px;
    }
.whiteboard {
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}

.colors {
  position: fixed;
}

.color {
  display: inline-block;
  height: 48px;
  width: 48px;
}

.color.black { background-color: black; }
.color.red { background-color: red; }
.color.green { background-color: green; }
.color.blue { background-color: blue; }
.color.yellow { background-color: yellow; }
`;
